<template>
  <div>
    <h1>Finance</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
